const PasswordEntropy = {
    lcase: "abcdefghijklmnopqrstuvwxyz",
    ucase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    numb: "1234567890",
    symbol: "!\"#$%&'()*+,-./:;<=>?@[]^_{|}~",

    _includesChar(text, charlist) {
        for (let i = 0; i < text.length; i++) {
            if (charlist.includes(text[i])) return true;
        }
        return false;
    },

    calculate(password) {
        if (typeof password !== "string") return 0;

        let pool = 0;
        if (this._includesChar(password, this.lcase)) pool += this.lcase.length;
        if (this._includesChar(password, this.ucase)) pool += this.ucase.length;
        if (this._includesChar(password, this.numb)) pool += this.numb.length;
        if (this._includesChar(password, this.symbol))
            pool += this.symbol.length;
        if (
            !this._includesChar(
                password,
                this.lcase + this.ucase + this.numb + this.symbol,
            )
        )
            pool += 100;

        if (pool === 0) return 0;

        return Math.round((password.length * Math.log(pool)) / Math.LN2);
    },
};

export default PasswordEntropy;
